import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import { IEmissionClass, IEngineType, Vehicle } from "../../types/vehicles";
import basicRequest from "../basicRequest";

type PostFleetRequest = { engineType: IEngineType[]; emissionClass: IEmissionClass[]; fleet: Vehicle[] };

export const fleetService = {    
    getFleet: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getFleet);
    },
    getFleetInfo: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getFleetInfo);
    },
    postFleet: async (data: PostFleetRequest): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.postFleet, data);
    },
}